import { Alert, Box, Button, Container, Typography } from '@mui/material'
import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: undefined })
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="md">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
              textAlign: 'center',
              gap: 3,
            }}
          >
            <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
              <Typography variant="h5" component="h1" gutterBottom>
                Something went wrong
              </Typography>
              <Typography variant="body1">
                {this.state.error?.message || 'An unexpected error occurred'}
              </Typography>
            </Alert>
            <Button variant="contained" color="primary" onClick={this.handleReset}>
              Try Again
            </Button>
          </Box>
        </Container>
      )
    }

    return this.props.children
  }
}
